import styles from './PaymentBreakdown.module.css';
import cn from 'classnames';
import FeeSetBreakdown, { mapFeeListToFeeItems } from '../FeeSetBreakdown/FeeSetBreakdown';
import { creatorbase } from '@round/api';

type Props = {
    className?: string;
    costs: creatorbase.PostCostPreview | null | undefined;
    selectedCurrencyId: number | undefined;
    campaignCurrencyId: number | undefined;
    provider: creatorbase.PaymentProvider | null | undefined;
    isLoading?: boolean;
    isFetching?: boolean;
};

const PaymentBreakdown = ({
    className,
    costs,
    selectedCurrencyId,
    campaignCurrencyId,
    provider,
    isLoading = false,
    isFetching = false,
}: Props) => {
    const shouldDisplayVAT = provider !== 'OTHER' && !!costs?.vat_amount;
    const payerFees = mapFeeListToFeeItems(costs?.payer_fees_list, costs?.campaign_currency_base_cost);
    const creatorFee = costs?.payee_receives
        ? costs?.payee_receives + costs.payee_fees_list?.reduce((acc, fee) => acc + fee.value, 0)
        : undefined;
    const payeeFees = mapFeeListToFeeItems(costs?.payee_fees_list, creatorFee);

    return (
        <div className={cn(styles.breakdown, className)}>
            <FeeSetBreakdown
                label="Creator Receives"
                feeSet={payeeFees}
                baseCost={creatorFee}
                total={costs?.payee_receives}
                currencyId={costs?.payee_receives_currency}
                isPending={isLoading}
                isFetching={isFetching}
                baseCurrencyId={selectedCurrencyId}
                exchangeRate={costs?.payee_receives_fx_rate}
                vatRate={shouldDisplayVAT ? costs?.vat_rate : undefined}
                vatAmount={shouldDisplayVAT ? (creatorFee ?? 0) * costs?.vat_rate : undefined}
            />

            <FeeSetBreakdown
                label="Total Amount Payable"
                feeSet={payerFees}
                baseCost={costs?.campaign_currency_base_cost}
                total={costs?.cost}
                currencyId={campaignCurrencyId}
                isPending={isLoading}
                isFetching={isFetching}
                baseCurrencyId={selectedCurrencyId}
                exchangeRate={costs?.campaign_currency_fx_rate}
            />
        </div>
    );
};

export default PaymentBreakdown;
